/**
 * web/src/screens/Settings/tabs.ts — the pinned section tabs and the
 * deep-link vocabulary (card MudceTexpbq1: moved verbatim out of index.tsx,
 * which re-exports the two helpers so the router's import is unchanged).
 */
import { type SubTabDef } from '../../components/SubTabs';

/**
 * Pinned sections (card DI31pLXCFc2C, Jonathan email 2026-10-12): Settings
 * was one long page; it is now tabbed submenus like JitsLab — one section on
 * screen at a time, ordered for comprehension: identity → relationship →
 * agent → billing → account. Same SubTabs row every other screen uses.
 */
export const SETTINGS_TABS: SubTabDef[] = [
  { key: 'you', label: 'You' },
  { key: 'us', label: 'Us' },
  { key: 'concierge', label: 'Concierge' },
  { key: 'plan', label: 'Plan' },
  { key: 'about', label: 'About' },
];
/** Deep-link vocabulary: #settings-<key> opens Settings on that section. */
export const SETTINGS_TAB_KEYS = SETTINGS_TABS.map(t => t.key);
export const settingsTabFromHash = (hash: string): string | null => {
  const m = /^#settings-([a-z]+)$/.exec(hash);
  return m && SETTINGS_TAB_KEYS.includes(m[1]) ? m[1] : null;
};
